import { CURRENT_CLIENT_ID_KEY } from '@core';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { childClientAdapter, type ChildClientState } from './clients-managements.reducer';

const { selectAll } = childClientAdapter.getSelectors();

export const selectChildClientState = createFeatureSelector<ChildClientState>('clients');

export const selectChildClients = createSelector(selectChildClientState, selectAll);

export const childClientIsLoading = createSelector(selectChildClientState, state => state.isLoading);

export const selectChildClientById = (childClientId: string) => {
  return createSelector(selectChildClients, clientList => clientList.find(client => client.id === childClientId));
};

export const getCurrentClientId = createSelector(
  selectChildClientState,
  state => {
    const queryClientId = new URLSearchParams(document.location.search).get(CURRENT_CLIENT_ID_KEY);

    return state.currentClientId ?? queryClientId ?? '';
  },
);

export const getCurrentClient = createSelector(
  selectChildClients,
  getCurrentClientId,
  (clientList, clientId) => clientList.find(client => client.id === clientId),
);
